import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import SendToPatientModal from './SendToPatientModal'
import { sharingEnabled } from './api'

// Acción "Enviar al paciente" sobre el turno. Solo para turnos originados en
// crontu (crontu resuelve el contacto del paciente del booking) y con el
// feature habilitado por env (REACT_APP_SHARING_API_URL).
//
// Pedido de Eilu (2026-08-31), corregido el mismo día tras reporte de QA:
// solo turnos CONFIRMADOS. El primer intento chequeaba pricing/mercadopago
// (el mecanismo de pago NATIVO de DrApp con MercadoPago) — pero un turno de
// origen crontu NUNCA completa esos campos (confirmado contra datos reales
// de QA, team 06a46fbc): Crontu gestiona el pago de su lado y lo único que
// nos informa es el `status` del turno. `pending` = reservado pero sin
// confirmar el pago todavía (turno de prueba real: 15/9, Juan Cruz Ises);
// `booked` = confirmado (mismo paciente, turno de prueba real: 8/9). Por
// eso el chequeo correcto es sobre `status`, no sobre pricing/mercadopago.
const SendToPatient = ({ event }) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  if (!sharingEnabled()) return null
  if (!event?.id || event.source !== 'crontu' || (event.type || 'appointment') !== 'appointment') return null
  if (event.status === 'cancelled' || event.status === 'pending') return null

  return (
    <>
      <button
        type="button"
        data-testid="send-to-patient-button"
        className="btn btn-sm bg-light link-primary w-100 d-flex justify-content-between align-items-center"
        onClick={() => setShow(true)}
      >
        <div>{t('send_to_patient', 'Enviar al paciente')}</div>
        <div>&rarr;</div>
      </button>
      {show && <SendToPatientModal event={event} onClose={() => setShow(false)} />}
    </>
  )
}

export default SendToPatient
